import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalTambah extends React.Component {
    render() {
        const { ShowModalDel, CancelHandler, DeleteHandler2, Model } = this.props

        return (
            <div>
                <Modal show={ShowModalDel} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>HAPUS PASIEN</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Anda yakin ingin menghapus Pasien <br/> <br/> 
                        <span class="error">{Model.fullname}</span>  
                        <br/> <br/>
                        <p>Riwayat medis akan tetap tersimpan, namun Anda tidak dapat lagi membuat janji dokter / chat online untuk pasien ini</p>
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={CancelHandler}>Tidak</button>
                        <button class="btn btn-danger" onClick={() => DeleteHandler2()}>Yakin</button>
                         

                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}